import { getAuthHeaders } from './utils';

export const fetchConfigurations = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/configurations`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || 'Failed to fetch configurations');
    }
    return res.json();
};

export const updateConfiguration = async (key, value) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/configurations/update`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ key, value }),
    });
    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.message || 'Failed to update configuration');
    }
    return data;
};
